export const tourText = {
  analyticsOverview: {
    title: 'Track Your Impact',
    description: 'See how learners engage with your content.',
  },
  analyticsWelcome: {
    title: 'Welcome to Analytics',
    description: 'Real-time insights into learner progress.',
  },
  analyticsFilter: {
    title: 'Filter Courses',
    description: 'Use this dropdown to filter by course.',
  },
};
